'use client';

import React, { Suspense } from 'react';
import { AuthProvider } from '@/components/providers/AuthProvider';
import { OrganizationProvider } from '@/components/providers/OrganizationProvider';
import { NotificationProvider } from '@/components/providers/NotificationProvider';
import { LanguageProvider } from '@/components/providers/LanguageProvider';
import RadialSpinner from '@/components/ui/RadialSpinner';

function AuthFallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <RadialSpinner className="w-10 h-10 text-slate-500/80" />
    </div>
  );
}

export default function AppProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Suspense fallback={<AuthFallback />}>
      <LanguageProvider>
        <AuthProvider>
          <OrganizationProvider>
            <NotificationProvider>{children}</NotificationProvider>
          </OrganizationProvider>
        </AuthProvider>
      </LanguageProvider>
    </Suspense>
  );
}
